/**
 * Custom cell component generator — creates stub cell components for custom column types
 */

import type { GeneratedFile, GeneratorOptions, Schema } from '@core-engine/schema/types.js'
import { createGeneratedFile } from '@core-engine/utils/generated-files.js'
import { singularize, toPascalCase } from '@core-engine/utils/string.js'
import { resolveSchemaActionImportPath } from '@next-adapter/config/paths.js'

export function createCustomCellComponent(
  schema: Schema,
  componentName: string,
  pagesDir: string,
  options: GeneratorOptions = {}
): GeneratedFile[] {
  const singular = singularize(schema.name)
  const Singular = toPascalCase(singular)
  const actionImportPath = resolveSchemaActionImportPath(schema.name, options.outputNamespace)

  const content = `import type { ${Singular} } from '@admin/actions/${actionImportPath}'

interface ${componentName}Props {
  data: ${Singular}
}

export function ${componentName}({ data }: ${componentName}Props) {
  return (
    <div>
      {JSON.stringify(data)}
    </div>
  )
}
`

  return [createGeneratedFile(`${pagesDir}/${schema.name}/cells/${componentName}.tsx`, content)]
}
